import { useState, useEffect } from "react";
import AddAppointmentModal from "../Modals/AddApointmentModal";
import { AppointmentTable } from "../Tables";
import axios from "axios";
import { BaseUrl } from "../../BaseUrl";
import { toast } from "react-hot-toast";
import { appointmentsData } from "../Datas";

function AppointmentsUsed({ doctor, patientId }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch appointments for patient
  useEffect(() => {
    const fetchAppointments = async () => {
      if (!patientId) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        // Note: You may need to adjust this endpoint based on your backend API
        // This endpoint might need to filter by patientId
        const response = await axios.get(`${BaseUrl}/doctor/appointments`, {
          withCredentials: true,
          params: { patientId },
        });

        if (response.data?.data && Array.isArray(response.data.data)) {
          // Filter appointments by patientId if backend doesn't filter
          const filteredAppointments = response.data.data.filter(
            (apt) => apt.patientId === patientId || apt.patient?._id === patientId || apt.userId === patientId
          );
          setAppointments(filteredAppointments);
        } else if (Array.isArray(response.data)) {
          const filteredAppointments = response.data.filter(
            (apt) => apt.patientId === patientId || apt.patient?._id === patientId || apt.userId === patientId
          );
          setAppointments(filteredAppointments);
        } else {
          setAppointments([]);
        }
      } catch (error) {
        console.error("Error fetching appointments:", error);
        // Don't show error if it's just no appointments found
        if (error.response?.status !== 404) {
          toast.error(error.response?.data?.message || "Failed to load appointments");
        }
        setAppointments([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAppointments();
  }, [patientId]);

  // onClick event handler
  const handleEventClick = (event) => {
    setData(event);
    setOpen(!open);
  };
  // handle modal close
  const handleClose = () => {
    setOpen(!open);
    setData({});
  };

  return (
    <div className='w-full'>
      {open && (
        <AddAppointmentModal
          datas={data}
          isOpen={open}
          closeModal={() => {
            handleClose();
          }}
        />
      )}
      <h1 className='mb-6 text-sm font-medium'>Appointments</h1>
      {loading ? (
        <div className='flex items-center justify-center py-10'>
          <p className='text-textGray'>Loading appointments...</p>
        </div>
      ) : (
        <div className='w-full overflow-x-scroll'>
          <AppointmentTable
            data={appointments.length > 0 ? appointments : appointmentsData}
            doctor={doctor}
            functions={{
              preview: handleEventClick,
            }}
          />
        </div>
      )}
    </div>
  );
}

export default AppointmentsUsed;
